import './Summary.scss'

import React from 'react'
import { useSelector } from 'react-redux'

import { hasSelectedTickets as hasSelectedTicketsSelector } from '../../selectors/selectors'
import CustomerLogin from './CustomerLogin/CustomerLogin'
import DesktopVouchers from './DesktopVouchers/DesktopVouchers'
import PaymentSection from './PaymentSection/PaymentSection'
import SelectedSerialTickets from './SelectedSerialTickets/SelectedSerialTickets'
import TotalPrice from './TotalPrice/TotalPrice'

export default function Summary() {
  const hasSelectedTickets = useSelector(hasSelectedTicketsSelector)

  return (
    <div className="summary">
      <CustomerLogin />
      {hasSelectedTickets && (
        <>
          <SelectedSerialTickets />
          <TotalPrice />
          <DesktopVouchers />
          <PaymentSection />
        </>
      )}
    </div>
  )
}
